import { IDataSource } from '~src/datasource/ServerApi/types/IDataSource';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { FlowOutputStep } from '../types/FlowOutputStep';
import { FlowOutputStepRun } from '../types/FlowOutputStepRun';
import { IDataConnection } from '../types/IDataConnection';
import { LinkedTask } from '../types/LinkedTask';
import { INamedItem } from '../types/resourceParts';

export type GetLinkedTaskParams = {
  readonly id: string;
}

export type GetLinkedTaskResult = IResult & {
  readonly linkedTask: LinkedTask;
  readonly flowOutputStepRuns: FlowOutputStepRun[];
  readonly outputSteps: FlowOutputStep[];
  readonly flows: INamedItem[];
  readonly dataConnections: IDataConnection[];
  readonly datasources: IDataSource[];
};

export class GetLinkedTaskRequest extends Request<GetLinkedTaskParams, GetLinkedTaskResult> {
  constructor(params: GetLinkedTaskParams) {
    super('getLinkedTask', params);
  }
}
